import { styled, Box, Stack, Typography } from '@mui/material'
import { Card, CardHeader } from 'components'

export const Container = styled(Stack)`
  gap: 10px;
  height: 100%;
`
export const PageWrapper = styled(Stack)`
  flex-direction: row;
  width: 100%;
  flex: 1;
  gap: 10px;
`
export const SectionCard = styled(Card)`
  flex: 4;
  display: flex;
  flex-direction: column;
`
export const StyledCardHeader = styled(CardHeader)`
  padding: 0 20px;
`
export const SectionTitle = styled(Typography)`
  font-weight: bold;
  font-size: 22px;
`
export const TableContainer = styled(Box)`
  padding: 0 8px;
  overflow: auto;
`
